export interface SelectOption<V> {
  value: V;
  label: string;
}

interface StepKeys {
  altKey: boolean;
  downKey: boolean;
  shiftKey: boolean;
  upKey: boolean;
}

/**
 * Get numeric step value for given pressed keys.
 */
export function getStepForKey(baseStep: number, keys: StepKeys): number {
  const step = baseStep * (keys.altKey ? 0.1 : 1) * (keys.shiftKey ? 10 : 1);

  if (keys.upKey) {
    return +step;
  } else if (keys.downKey) {
    return -step;
  }
  return 0;
}

/**
 * Get pressed keys state for horizontally steppable inputs.
 */
export function getHorizontalStepKeys(ev: KeyboardEvent): StepKeys {
  return {
    altKey: ev.altKey,
    downKey: ev.keyCode === 37,
    shiftKey: ev.shiftKey,
    upKey: ev.keyCode === 39
  };
}

/**
 * Get pressed keys state for vertically steppable inputs.
 */
export function getVerticalStepKeys(ev: KeyboardEvent): StepKeys {
  return {
    altKey: ev.altKey,
    downKey: ev.keyCode === 40,
    shiftKey: ev.shiftKey,
    upKey: ev.keyCode === 38
  };
}

/**
 * Get the number of decimal digits required to represent given step value.
 */
export function getSuitableDecimalDigits(
  rawValue: number,
  step?: number
): number {
  if (step != null) {
    return getDecimalDigits(step);
  }

  return Math.max(getDecimalDigits(rawValue), 2);
}

function getDecimalDigits(value: number): number {
  if (!Number.isFinite(value)) {
    return 0;
  }
  const text = String(value.toFixed(10));
  const frac = text.split('.')[1];
  return frac.replace(/0+$/, '').length;
}
